/**
 * Validates a `next` redirect target and returns it as a path on this origin,
 * or null when it points anywhere else.
 *
 * Resolving against the current origin rather than checking the string is what
 * catches `/\evil.com`, which browsers read as protocol-relative. A
 * cross-origin target makes history.pushState throw a SecurityError, and
 * assigning one to window.location redirects the user off-site.
 */
export const getSafeNextUrl = (next: unknown): string | null => {
  if (typeof next !== 'string' || !next.startsWith('/')) {
    return null;
  }

  try {
    const url = new URL(next, window.location.origin);
    if (url.origin !== window.location.origin) {
      return null;
    }

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
};
